module.exports = __webpack_public_path__ + "static/a-xx-178-art-b547a2b5e09ee0718c6cff9b560d6a49.jpg";